import service from '@/utils/request'

// 列表查询
export const getList = (params: any) =>
  service.request({
    method: 'post',
    url: '/operation/notice/page',
    data: params
  })

// 新增
export const add = (params: any) =>
  service.request({
    method: 'post',
    url: '/operation/notice/add',
    data: params
  })

// 编辑
export const update = (params: any) =>
  service.request({
    method: 'post',
    url: '/operation/notice/edit',
    data: params
  })

// 详情
export const detail = (params: any) =>
  service.request({
    method: 'post',
    url: '/operation/notice/detail',
    data: params
  })

// 企业下拉框
export const dropdownOfEnterprise = (params: any) =>
  service.request({
    method: 'post',
    url: '/admin/enterprise/dropdownOfEnterprise',
    data: params
  })
